import React from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Privacy() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-yellow-50 to-orange-50 flex justify-center p-4 pt-20">
      {/* --- MAIN CARD --- */}
      <div className="w-full max-w-4xl bg-white rounded-2xl shadow-xl border">
        {/* --- Screenshot-Style Back Button INSIDE card header --- */}
        <div className="flex items-start p-6 pb-2">
          <button
            onClick={() => navigate(-1)}
            className="
              w-14 h-12 bg-white rounded-2xl 
              shadow-[0_4px_12px_rgba(0,0,0,0.1)] 
              flex items-center justify-center 
              border border-gray-100
              hover:shadow-[0_6px_16px_rgba(0,0,0,0.15)]
              transition-all
            "
          >
            <div className="flex items-center gap-2">
              <ArrowLeft size={22} className="text-orange-500" />
            </div>
          </button>
        </div>

        {/* --- Card Body --- */}
        <div className="px-8 md:px-10 pb-10">
          <h1 className="text-3xl md:text-4xl font-serif font-bold text-neutral-900 mb-4">
            Privacy Policy
          </h1>

          <p className="text-gray-600 mb-8">
            Last updated: <span className="font-semibold">January 2025</span>
          </p>

          {/* SECTION 1 */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-neutral-900 mb-3">
              1. Introduction
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Welcome to the Purohit App. Your privacy is extremely important to
              us. This Privacy Policy explains how we collect, use, protect, and
              handle your personal information when you use our services.
            </p>
          </section>

          {/* SECTION 2 */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-neutral-900 mb-3">
              2. Information We Collect
            </h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Personal Details (Name, Email, Phone Number)</li>
              <li>Location Information (City for service matching)</li>
              <li>Usage Data (Interaction logs, device information)</li>
              <li>Login Details (For secure authentication only)</li>
            </ul>
          </section>

          {/* SECTION 3 */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-neutral-900 mb-3">
              3. How We Use Your Information
            </h2>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>To create and maintain user accounts</li>
              <li>To connect users with verified Purohits</li>
              <li>To improve user experience and app performance</li>
              <li>To send notifications, alerts, and OTPs</li>
              <li>To ensure account security and fraud prevention</li>
            </ul>
          </section>

          {/* SECTION 4 */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-neutral-900 mb-3">
              4. Data Protection & Security
            </h2>
            <p className="text-gray-700 leading-relaxed">
              We use industry-standard encryption, secure servers, and strict
              authentication processes to protect your personal information.
              Your data is never shared with unauthorized third parties.
            </p>
          </section>

          {/* SECTION 5 */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-neutral-900 mb-3">
              5. Sharing of Information
            </h2>
            <p className="text-gray-700 leading-relaxed">
              We do <b>NOT</b> sell, trade, or rent your personal information.
              We may share essential details only with:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mt-2">
              <li>Verified Purohits for booking purposes</li>
              <li>Legal authorities when required by law</li>
              <li>Service providers that support app functionality</li>
            </ul>
          </section>

          {/* SECTION 6 */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-neutral-900 mb-3">
              6. Your Rights
            </h2>
            <p className="text-gray-700 leading-relaxed">
              You have full control over your privacy. You may:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mt-2">
              <li>Update your profile information anytime</li>
              <li>Request account deletion</li>
              <li>Opt out of notifications</li>
              <li>Request data access or correction</li>
            </ul>
          </section>

          {/* SECTION 7 */}
          <section className="mb-8">
            <h2 className="text-xl font-semibold text-neutral-900 mb-3">
              7. Changes to This Policy
            </h2>
            <p className="text-gray-700 leading-relaxed">
              We may update this Privacy Policy periodically. You will be
              notified of major changes through the app or email.
            </p>
          </section>

          {/* Contact Section */}
          <section>
            <h2 className="text-xl font-semibold text-neutral-900 mb-3">
              8. Contact Us
            </h2>
            <p className="text-gray-700 leading-relaxed">
              For any questions, concerns, or privacy requests, please contact:
            </p>
            <p className="mt-2 font-semibold text-orange-600">
              support@purohitapp.com
            </p>
          </section>

          {/* --- I UNDERSTAND BUTTON --- */}
          <div className="mt-10 flex justify-center">
            <button
              onClick={() => navigate(-1)}
              className="
    bg-gradient-to-r from-orange-500 to-red-500 
    text-white font-semibold px-6 py-2 rounded-xl shadow-md
  "
            >
              I Understand
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
